import {Auditable} from './auditable.model';
import {GenericTypeDef} from '../../../../../../soko-console-web-v2/src/app/core/model/generic-type-def.model';

export class User extends Auditable {
  public disabled!: boolean;
  public email!: string;
  public firstname!: string;
  public lastLogin?: string;
  public lastname!: string;
  public locked?: boolean;
  public loginAttempts?: number;
  public secret?: string;
  public override verified!: boolean;
  public profileImage?: string;
  public contacts?: UserContacts[];
  public otpContactPreference?: 'EMAIL' | 'MOBILE_PHONE';

  constructor(obj: any) {
    super(obj);
    Object.assign(this, obj);
  }
}

export class RegisterUserRequest {
  public email!: string;
  public firstname!: string;
  public lastname!: string;
  public secret?: string;

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}

export class UpdateUserContactRequest {

  public userId: number;
  public userEmail: string;
  public mobileNumber: string;
  public otpContactPreference: 'EMAIL' | 'MOBILE_PHONE';

  constructor(obj: any = {}) {
    obj = obj || {};
    this.userId = obj.userId;
    this.userEmail = obj.userEmail;
    this.mobileNumber = obj.mobileNumber;
    this.otpContactPreference = obj.otpContactPreference;
  }
}

export class UserContacts {
  public id: number;
  public userId: number;
  public contactType: GenericTypeDef;
  public valueCode: string;
  public value: string;

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.userId = obj.userId;
    this.contactType = obj.contactType;
    this.valueCode = obj.valueCode;
    this.value = obj.value;
  }
}


export interface UserRetailerRelationshipDto {
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
  grantId: number;
  roleId: number;
  offeringUuid: string;
  retailerId: number;
  companyName: string;
}

export class VerifyOTPRequest {
  public id!: number;
  public pin!: string;

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}

export class UserUpdateRequest {
  public id!: number;
  public firstname!: string;
  public lastname!: string;

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}
